import { render } from "./NoCam.vue?vue&type=template&id=bd2ce3ea&scoped=true"
import script from "./NoCam.vue?vue&type=script&lang=js"
export * from "./NoCam.vue?vue&type=script&lang=js"

import "./NoCam.vue?vue&type=style&index=0&id=bd2ce3ea&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2ce3ea"]])

export default __exports__